import React, { useState, useRef } from 'react';
import axiosInstance from '../../axios'; // Adjust the import path if necessary
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from '@mantine/core';

const StudentFormUploader = ({handlePageUpdate}) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const fileInputRef = useRef(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      uploadFile(file); // Directly upload the file
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const uploadFile = (file) => {
    setUploading(true);

    // Prepare form data
    // console.log(file)
    const formData = new FormData();
    formData.append('file', file);

    axiosInstance.post('students/uploadExcel', formData, {
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percentCompleted);
      },
    })
    .then(res => {
      handlePageUpdate() 
      // console.log(res.data)
      setUploading(false);
      setProgress(0); // Reset progress
      //console.log(res.data)
      if (res.data.includes("Student with the same attendee_id already exists")) {
        toast.error("Student with the same ID already exists. Please check your Excel file.");
      } else if (res.data.includes("Invalid date format for DOB")) {
        toast.error("Incorrect date values found. Please correct the date format in your Excel file.");
      } 
      else if(res.data.includes("Training center doesn't exist...")){
        toast.error("Training centre doesn't exists. Please add the training centre in the system.");
      }
      else if(res.data.includes("No batch found")){
        toast.error("Batch doesn't exists. Please add the batch in the system.");
      }
      

      else{
        toast.success("Student data inserted successfully");
      }
    })
    .catch(error => {
      toast.error("Error uploading student data:", error);
      setUploading(false);
      handlePageUpdate()
      setProgress(0); // Reset progress
    });
  };

  return (
    <div>
      <Button 
        onClick={handleButtonClick}
        color="blue"
        radius="none"
        size="sm"
        style={{ backgroundColor: '#548c2f', color: '#fff', fontWeight: 'bold', border: 'none' }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#548c2f'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#548c2f'}
      >
        Upload Excel
      </Button>
      
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        ref={fileInputRef}
        style={{ display: 'none' }} // Hide the file input
      />
      {uploading && (
        <div>
          <p>Uploading... {progress}%</p>
          <progress value={progress} max="100" style={{ width: '100%' }} />
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default StudentFormUploader;
